import { useContext } from "react"

import { ThemeProviderContext } from "./theme-context"

export const useTheme = () => {
  const context = useContext(ThemeProviderContext)

  // Context will always be defined due to initialState, but keep the check for safety
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (context === undefined) throw new Error("useTheme must be used within a ThemeProvider")

  return context
}
